import {l} from "types/typescriptdefinisjoner_lederplan";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {gettextCatalog} from "angular-gettext";
import {IPromise} from "q";


export class SystemmeldingRessurs {
    static regNavn = "SystemmeldingRessurs";

    static forInjisering() {
        return [
            "$resource",
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            SystemmeldingRessurs
        ]
    }

    private ressurs: ng.resource.IResourceClass<any>;

    constructor(private $resource: ng.resource.IResourceService,
                private ressursFeilhåndtering: RessursFeilhåndtering,
                private gettextCatalog: gettextCatalog) {
        this.ressurs = $resource<any>("/api/admin/melding", {}, {
            hent: {method: 'GET', url: '/api/admin/melding/:id', params: {id: '@id'}},
            hentMedType: {method: 'GET', url: '/api/admin/melding/hentMedType/:type', params: {type: '@type'}, isArray: true},
            finnAlle: {method: 'GET', url: '/api/admin/melding/finnAlle', isArray: true},
            slett: {method: 'DELETE', url: '/api/admin/melding/:id', params: {id: '@id'}},
            opprett: {method: 'PUT', url: '/api/admin/melding/'}
        });
    }

    hent(id: string): l.SystemMeldingModell {
        return this.ressurs['hent'](
            {id: id},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Fant ikke systemmelding")));
    }

    hentMedType(type: l.Meldingstype[]): l.SystemMeldingModell[] {
        return this.ressurs['hentMedType'](
            {type: angular.toJson(type)},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Feil ved lasting av systemmeldinger")));
    }

    hentAktivForType(type: l.Meldingstype): IPromise<l.SystemMeldingModell | null> {
        return this.hentMedType([type]).$promise
            .then((meldinger) => {
                return meldinger.length > 0 ? meldinger[0] : null;
            })
    }

    finnAlle(): l.SystemMeldingModell[] {
        return this.ressurs['finnAlle'](
            {},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke hente systemmelding")));
    }

    slett(id) {
        return this.ressurs["slett"](
            {id: id},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke slette melding"))
        );
    }

    opprett(spesifikasjon: l.OpprettSystemMeldingSpesifikasjon) {
        return this.ressurs["opprett"](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke opprette melding"))
        );
    }

    static meldingstypeSomTekst(meldingstype: l.Meldingstype) {
        switch(meldingstype){
            case l.Meldingstype.loggInnBankId: return "Logginn BankID";
            case l.Meldingstype.loggInnHoved: return "Logginn Topp";
            case l.Meldingstype.mal: return "Mal";
            case l.Meldingstype.detteErNyttForAdmin: return "Dette er nytt: for admin";
            case l.Meldingstype.detteErNyttForMedlem: return "Dette er nytt: for medlem";
            case l.Meldingstype.detteErNyttForTesting: return "Dette er nytt: for styreplan-ansatte (testing)";
            case l.Meldingstype.applikasjonHoved: return "Generell melding i applikasjon";
            default: return "";
        }
    }

    private håndterFeil(melding: () => string){
        return this.ressursFeilhåndtering.håndterRequestFeil(melding);
    }
}
